import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const crmPipelineValueWidget: DashboardWidgetConfiguration = {
  widgetId: "crm.pipeline-value",
  name: "Pipeline value",
  description: "Pipeline value for the selected dashboard period.",
  apps: [
    "home",
    "crm",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "crm.prospects",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "expected_value",
          as: "value",
        },
      ],
      where: {
        type: "condition",
        field: "prospect_type",
        operator: "eq",
        value: "opportunity",
      },
    },
  },
  inputs: {
    label: "Pipeline value",
    subtext: "in the last 30 days",
    icon: "money",
    color: "purple",
    valueFormat: "currency",
    valueMultiplier: 1,
  },
  dummyData: {
    value: "$128,400",
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
